export const types = {
  GET_LIST_CAMPAIGNS: 'GET_LIST_CAMPAIGNS',
  GET_LIST_CAMPAIGNS_SUCCESS: 'GET_LIST_CAMPAIGNS_SUCCESS',
  GET_LIST_CAMPAIGNS_FAIL: 'GET_LIST_CAMPAIGNS_FAIL',
}